const NdaTemplatesRoutes = {
  create: "nda/template/create",
  getTemplate: "nda/templates",
  getDetails: "nda/template/",
  updatedTemplate: "nda/template/update/"
};

export default NdaTemplatesRoutes